import React from 'react';
import useTheme from '../hooks/useTheme';

interface IconWrapProps {
  icon: React.ReactNode;
  size?: number;
  color?: 'default' | 'primary' | 'muted';
  style?: React.CSSProperties;
}

export const IconWrap: React.FC<IconWrapProps> = ({
  icon,
  size = 18,
  color = 'muted',
  style = {},
}) => {
  const { theme } = useTheme();

  const colorMap = {
    default: theme.text.primary,
    primary: theme.colors.green.g1,
    muted: theme.text.muted,
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: `${size}px`,
        color: colorMap[color],
        ...style,
      }}
    >
      {icon}
    </span>
  );
};

